import { useEffect, useState } from 'react';

export type TCustomCallback = () => void;

const useDebounceCallbacks = () => {
  const [callbacks, setCallbacks] = useState<TCustomCallback[]>([]);

  const debounce = (callback: TCustomCallback, delay: number) => {
    const handler = setTimeout(() => {
      callback();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  };

  const addCallback = (callback: TCustomCallback, delay: number) => {
    const removeCallback = debounce(callback, delay);
    setCallbacks([...callbacks, removeCallback]);
  };

  const clearCallbacks = () => {
    callbacks.forEach(removeCallback => {
      removeCallback();
    });
    setCallbacks([]);
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    return () => {
      clearCallbacks();
    };
  }, []);

  return { addCallback, clearCallbacks };
};

export default useDebounceCallbacks;
